export function buildWorkflowTenantHeaders(tenantId, headers = {}) {
    if (!tenantId) {
        return headers;
    }
    return {
        ...headers,
        'X-Tenant-ID': tenantId,
    };
}
